module.exports = __webpack_public_path__ + "static/encryption-5cf9aa3e01dda130a2f72d4a5925be94.png";